/* global moment: false */
import format from 'number-format.js'
import * as mTypes from './store/mutation-types'

export const perPageItem = 20
export const perPageFeedback = 20
export const perPageContactLog = 10

export function numberFormat (n, fillZero = false) {
  return format(fillZero ? '#,##0.00' : '#,##0.##', n)
}

export function getCfItems (list) {
  return list.map(item => {
    return {
      name: item.name,
      value: `¥${numberFormat(item.value, true)}`,
      update: `${item.update}`,
      valueSuffix: '已筹',
      to: {
        path: '/main/cf/project/feedback',
        query: {
          projectId: item.id
        }
      }
    }
  })
}

export function getFormItems (list) {
  return list.map(item => {
    return {
      name: item.name,
      value: item.value,
      update: `${item.update}`,
      valueSuffix: '份反馈',
      enablePrivateForm: item.enablePrivateForm,
      to: {
        path: '/main/form/feedback',
        query: {
          formId: item.id
        }
      }
    }
  })
}

export function getActivityItems (list) {
  return list.map(item => {
    return {
      id: item.id,
      title: item.title,
      signedUpUserCount: item.signed_up_user_count,
      valueSuffix: '总报名人数',
      to: {
        path: '/main/activity/detail',
        query: {
          activityId: item.id
        }
      }
    }
  })
}

export function networkError (commit) {
  const html = `
    <h1>网络不给力呀~</h1>
    <p>请稍后刷新再试</p>
  `
  commit(mTypes.SET_DIALOG_HTML, html)
}

export function isFemale (gender) {
  let ret = false
  if (gender && (gender.toLowerCase() === 'female' || gender === '女')) {
    ret = true
  }
  return ret
}

export function unixFromNow (unix) {
  return moment.unix(unix).fromNow()
}

export function mapContactItem (data) {
  return {
    id: data.id,
    avatar: data.avatar,
    name: data.name,
    phone: data.mobile,
    isFemale: isFemale(data.gender),
    org: data.org || {}
  }
}

export function mapCfItem (data) {
  return {
    id: data.id,
    name: data.title,
    value: data.sum_paid,
    update: data.latest_donate_time ? `最新提交：${unixFromNow(data.latest_donate_time)}` : '暂无提交'
  }
}

export function mapFormItem (data) {
  return {
    id: data.id,
    name: data.title,
    value: data.formfill_count,
    update: data.last_fill_time ? `最新提交：${unixFromNow(data.last_fill_time)}` : '暂无提交',
    enablePrivateForm: data.enable_private_form
  }
}

function getLocalStorage () {
  let localStorage = null
  try {
    localStorage = window.localStorage
  } catch (e) {
    // Access denied :-(
  }
  return localStorage
}

export function getLocalStorageItem (key) {
  const localStorage = getLocalStorage()
  if (localStorage) {
    return localStorage.getItem(key)
  } else {
    return null
  }
}

export function setLocalStorageItem (key, data) {
  const localStorage = getLocalStorage()
  if (localStorage) {
    try {
      localStorage.setItem(key, data)
    } catch (e) {
      if (e.code === 22) {
        // Storage full, maybe notify user or do some clean-up
      }
    }
  }
}

const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webm']
export function isImageExt (ext) {
  return IMAGE_EXTENSIONS.indexOf(ext) >= 0
}

export function fetchFormItems (formItems, dataSource) {
  const rows = []

  /*
  // 字数过多效果测试
  formItems.name = {
    display_name: '嗷嗷嗷嗷嗷嗷嗷嗷嗷嗷嗷嗷嗷嗷'
  }
  dataSource['name'] = '嗷嗷嗷嗷嗷嗷嗷嗷嗷嗷嗷嗷嗷嗷'
  */

  for (const key in formItems) {
    const row = {}
    // icon
    switch (key) {
      case 'name':
        row.icon = 'name'
        break
      case 'email':
        row.icon = 'mail'
        break
      case 'mobile':
        row.icon = 'phone'
        row.type = 'tel'
        row.mobileCheck = dataSource[key + '_check']
        row.smsCheck = formItems[key]['sms_check']
        break
      case 'org_name':
        row.icon = 'org'
        break
      case 'address':
        row.icon = 'source'
        break
    }
    // name
    row.name = formItems[key].display_name
    row.type = formItems[key].type
    // value
    const value = dataSource[key]
    switch (formItems[key].type) {
      case 'text':
        row.icon = 'comment'
        row.content = value
        rows.push(row)
        break
      case 'address':
        row.icon = 'source'
        row.value = value
        rows.push(row)
        break
      case 'select_multi':
        row.value = (value && value.join) ? value.join('，') : value
        rows.push(row)
        break
      case 'select_multi_file':
        row.value = (value && value.join) ? value.join('，') : value
        rows.push(row)
        break
      case 'file':
      case 'draw_signature':
        if (value) {
          let values = []

          if (value instanceof Array) {
            values = value
          } else {
            values.push(value)
          }

          const files = []
          for (let i = 0; i < values.length; i++) {
            const file = {}
            file.value = values[i].name
            file.valueLink = values[i].path
            if (isImageExt(values[i].ext)) {
              file.image = values[i].path
              if (values[i].location === 'qiniu') {
                file.image = `${values[i].path}?imageView2/2/w/640/interlace/0/q/90` // scale
              }
            }

            files.push(file)
          }
          row.files = files
          rows.push(row)
        }
        break
      case 'address_geo':
        row.icon = 'source'
        row.value = `地址：${dataSource[key]} 经度：${dataSource[key + '_lng']} ；纬度：${dataSource[key + '_lat']}`
        rows.push(row)
        break
      case 'split':
        // 不显示
        break
      case 'note_array':
        row.value = value
        row.is_show_more = formItems[key]['is_show_more']
        row.current_num = formItems[key]['current_num']
        rows.push(row)
        break
      default:
        row.value = dataSource[key]
        rows.push(row)
        break
    }
  }

  return rows
}

export function fetchActivityItems (activityItems, dataSource) {
  const rows = []

  for (const key in activityItems) {
    const row = {}
    // icon
    switch (key) {
      case 'name':
        row.icon = 'name'
        break
      case 'email':
        row.icon = 'mail'
        break
      case 'mobile':
        row.icon = 'phone'
        row.type = 'tel'
        break
      case 'org_name':
        row.icon = 'org'
        break
      case 'address':
        row.icon = 'source'
        break
      case 'pay_bracket':
        row.icon = 'bracket'
        break
      case 'create_time_display':
        row.icon = 'datetime'
        break
    }
    // name
    row.name = activityItems[key].display_name
    // value
    const value = dataSource[key]
    switch (activityItems[key].type) {
      case 'text':
        row.icon = 'comment'
        row.content = value
        rows.push(row)
        break
      case 'address':
        row.icon = 'source'
        row.value = value
        rows.push(row)
        break
      case 'select_multi':
        row.value = (value && value.join) ? value.join('，') : value
        rows.push(row)
        break
      case 'file':
        if (value) {
          row.value = value.name
          row.valueLink = value.path
          if (isImageExt(value.ext)) {
            row.image = value.path
            if (value.location === 'qiniu') {
              row.image = `${value.path}?imageView2/2/w/640/interlace/0/q/90` // scale
            }
          }
          rows.push(row)
        }
        break
      case 'address_geo':
        row.icon = 'source'
        row.value = `地址：${dataSource[key]} 经度：${dataSource[key + '_lng']} ；纬度：${dataSource[key + '_lat']}`
        rows.push(row)
        break
      case 'split':
        // 不显示
        break
      default:
        row.value = dataSource[key]
        rows.push(row)
        break
    }
  }

  return rows
}



// WEBPACK FOOTER //
// ./src/utils.js